var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { grey } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
const StyledBox = styled(Box) `
    display: flex;
    align-items: stretch;
`;
const OptionsButton = styled(Button) `
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: 0;
    font-size: 75%;
    background: ${grey[800]};
    color: ${({ theme }) => theme.palette.getContrastText(grey[800])};
    padding: 4px 8px;
    &:hover {
        background: ${grey[700]};
        color: ${({ theme }) => theme.palette.getContrastText(grey[700])};
    }
`;
const StyledTitle = styled(Typography) `
    background: ${({ theme }) => theme.palette.success.main};
    color: ${({ theme }) => theme.palette.success.contrastText};
    vertical-align: middle;
    font-size: 75%;
    display: flex;
    align-items: center;
    padding: 0 8px;
    border-bottom-left-radius: 4px;
    text-transform: none;
`;
const StyledIcon = styled('span') `
    margin-right: 8px;
    display: flex;
    > svg {
        font-size: 18px;
    }
`;
export const ViewOptions = (props) => {
    const { children, onClick, icon, optionsButtonIcon, title, buttonText, buttonProps } = props, other = __rest(props, ["children", "onClick", "icon", "optionsButtonIcon", "title", "buttonText", "buttonProps"]);
    return (_jsxs(StyledBox, Object.assign({}, other, { children: [_jsxs(StyledTitle, { variant: 'button', children: [icon && _jsx(StyledIcon, { children: icon }), children] }), _jsx(OptionsButton, Object.assign({ variant: 'contained', endIcon: optionsButtonIcon !== null && optionsButtonIcon !== void 0 ? optionsButtonIcon : _jsx(KeyboardArrowDownIcon, {}), disableElevation: true }, buttonProps, { onClick: onClick, children: buttonText }))] })));
};
